<template>
    <div class="crumb-tab">
        <ul class="tab-list">
            <li v-for="(item, index) in tabList" :key="item.content">
                <router-link class="content" :class="{ active: index === tabList.length - 1 }" :to="{ path: item.url }">{{
                    item.content
                }}</router-link>
                <icon v-if="index !== tabList.length - 1" class="right-arrow" name="arrow-down"></icon>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'CrumbTab',
    components: {},
    props: {
        tabList: {
            type: Array,
            default: () => []
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.crumb-tab {
    height: 100px;
    background-color: #f5f5f5;
    padding: 30px 40px;
    .tab-list {
        display: flex;
        align-items: center;
        li {
            display: flex;
            align-items: center;
            margin-right: 20px;
            .content {
                margin-right: 20px;
                white-space: nowrap;
                font-weight: 400;
                font-size: 28px;
                color: #333;
                &.active {
                    color: #ce0e2d;
                    font-weight: 600;
                }
            }
            .right-arrow {
                width: 20px;
                transform: rotate(-90deg);
                position: relative;
                bottom: 2px;
                fill: #333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/investor/components/crumb-tab.vue